import { IHttpService } from './IHttpService';
import { Injectable } from '@angular/core';

// The API by site: only the live site calls the live API. Everything else (devlogin.garagedesks.com, localhost,
// Cloudflare Pages previews) calls the dev API, so a dev or preview copy can never touch live data.
const apiBaseUrl = window.location.hostname === 'login.garagedesks.com'
    ? 'https://api.fleetdesks.com'
    : 'https://devapi.fleetdesks.com';

export class EndpointConfig {
    private static _staticBaseUrl = apiBaseUrl;
    private _baseUrl = apiBaseUrl;
    constructor(public endpoint) { }

    public static getMvcUrl(controller, action, id?) {
        return `${this._staticBaseUrl}/api/${controller}/${action}${id == undefined ? '' : `/${id}`}`;
    }

    getEndPoint() {
        return `${this._baseUrl}/api/${this.endpoint}`;
    }

    getEndpointMethod(method) {
        return `${this._baseUrl}/api/${this.endpoint}/${method}`;
    }

    public getApiUrl() {
        return `${this._baseUrl}/api`;
    }

    public getControllerUrl(controllerName: string, actionName?: string) {
        return this.getApiUrl() + '/' + controllerName + (actionName ? '/' + actionName : '');
    }

}
